import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import config from '@plone/volto/registry';

/**
 * Customized ScrollToTop that also checks window.location.hash directly.
 *
 * The original only checks the hash from state.loadProtector.location,
 * but on SSR the hash fragment is never sent to the server, so the
 * Redux state's location never includes it. By also checking the
 * browser's actual hash, we avoid scrolling to top on client-side
 * navigation to a URL with a hash fragment.
 *
 * @class ScrollToTop
 * @extends {Component}
 */
class ScrollToTop extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    children: PropTypes.node.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const noInitialBlocksFocus =
      config.blocks?.initialBlocksFocus === null
        ? this.props.location?.pathname.slice(-5) !== '/edit'
        : true;

    const isHash =
      location?.hash ||
      location?.pathname?.hash ||
      (typeof window !== 'undefined' && window.location.hash);

    if (
      !isHash &&
      prevProps.location !== undefined &&
      noInitialBlocksFocus &&
      location?.pathname !== prevProps.location?.pathname
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default connect(
  (state, props) => ({
    location: state.loadProtector.location,
  }),
  {},
)(ScrollToTop);
